import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";
export class Transactions extends Model {

  static entity = 'transactions'
  static primaryKey = 'id'
  static apiEntity = 'transactions'

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      descr: this.attr(null),
      notes: this.attr(null),
      amount: this.attr(null),
      balance: this.attr(null),
      type: this.attr(null),
      date: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      user: this.attr(null),
    }
  }
//   static async fetch(){
//     const res = axios.get('/accounting/billings/positions')
//       .then(response => {
//         BillingPositions.insertOrUpdate({data:response.data['positions']})
//       })
//       .catch(error=>error)
//   }
}
export default Transactions



// WEBPACK FOOTER //
// ./src/store/models/accounting/transactions.js